import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { useEffect } from 'react';
import styles from './SimpleModal.module.css';

function SimpleModal({
  isOpen,
  onClose,
  containerProps,
  children
}
) {
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      <div
        className={styles.backdrop}
        onClick={onClose}>
        <div
          className={styles.contentContainer}
          style={{ ...containerProps }}
          onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    </>,
    document.body
  );
}

SimpleModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  containerProps: PropTypes.object,
  children: PropTypes.node,
}

export default SimpleModal;